import React, { Fragment, useEffect } from 'react';
import { Store } from '../store/Store';
import { withRouter } from '../routes/withRouter';
import { ApiService } from '../services/apiService';
import { REDUCER_ACTION_SET } from '../store/types';
import { SECURITY_SCREENS } from './SecurityGroups';
import { SORT_DIRECTION, sortList } from '../services/helperSort';

const api = ApiService.getInstance();

const GroupNewAreaFlipped = (props: any) => {
  const { groupSelected, back, next, valuesInit } = props;

  const s = React.useContext(Store);
  const store = s.store;
  const dispatch = s.dispatch;

  // eslint-disable-next-line
  const [users, setUsers] = React.useState([]);
  // eslint-disable-next-line
  const [areas, setAreas] = React.useState([]);
  const [subAreas, setSubAreas] = React.useState([]);
  const [values, setValues] = React.useState<any>(valuesInit);
  const [mappingCount, setMappingCount] = React.useState<number>(0);

  // eslint-disable-next-line
  const getUsers = async () => {
    const usersFetched = await api.getUsers(s.store?.organisationSelected?.organisationId);
    if (usersFetched) {
      setUsers(usersFetched);
      // const storeAction = {
      //   type: REDUCER_ACTION_SET.SET_AREAS,
      //   payload: areasFetched,
      // };
      // dispatch(storeAction);
    }
  };

  const getAreas = async () => {
    const areasFetched = await api.getAreas(store?.organisationSelected?.organisationId);
    if (areasFetched) {
      setAreas(areasFetched);
      const storeAction = {
        type: REDUCER_ACTION_SET.SET_AREAS,
        payload: areasFetched,
      };
      dispatch(storeAction);
    }
  };

  const getSubAreas = async () => {
    let subAreasFetched = await api.getSubAreas(store?.organisationSelected?.organisationId);
    if (subAreasFetched) {
      // sort sub areas
      const newValues = { ...values };
      subAreasFetched = sortList(subAreasFetched, ['Name'], SORT_DIRECTION.ASC);
      newValues.sortListSubAreaDirectionFlipped = SORT_DIRECTION.ASC;
      // sort areas
      subAreasFetched.forEach((area: any) => {
        if (!Array.isArray(area.AreasSubareas)) return;
        const sortedList = sortList(area.AreasSubareas, ['Area', 'Name'], SORT_DIRECTION.ASC);
        area.AreasSubareas = sortedList;
      });
      newValues.sortListAreaDirectionFlipped = SORT_DIRECTION.ASC;
      setValues(newValues);

      setSubAreas(subAreasFetched);
      const storeAction = {
        type: REDUCER_ACTION_SET.SET_SUB_AREAS,
        payload: subAreasFetched,
      };
      dispatch(storeAction);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (async () => {
      getAreas();
      getSubAreas();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!valuesInit || !valuesInit.groupSelected || !valuesInit.groupSelected.PermissionGroupAreasSubAreas || valuesInit.screenPrev !== SECURITY_SCREENS.GROUP_LIST) return;

    const groupSelected = valuesInit.groupSelected;

    const newGroupMappings: any = {
      groupMappings: {
        subArea: {},
      },
    };
    groupSelected.PermissionGroupAreasSubAreas.forEach((permission: any, i: number) => {
      if (i === 0) {
        newGroupMappings.groupMappings['area'] = permission.B2SAreaId;
      }

      if (permission.B2SAreaSubarea && permission.B2SAreaSubarea.AreaId && !newGroupMappings.groupMappings.subArea[permission.B2SAreaSubarea.AreaId]) {
        newGroupMappings.groupMappings.subArea[permission.B2SAreaId] = { checked: {} };
      }
      if (permission.B2SAreaSubarea && permission.B2SAreaSubarea.SubareaId) {
        newGroupMappings.groupMappings.subArea[permission.B2SAreaSubarea.AreaId].checked[permission.B2SAreaSubarea.SubareaId] = permission.B2SAreaSubarea.SubareaId ? true : false;
      }

      if (!newGroupMappings.groupMappings.areaFlipped) {
        newGroupMappings.groupMappings.areaFlipped = {};
      }
      if (!newGroupMappings.groupMappings.areaFlipped) {
        newGroupMappings.groupMappings.areaFlipped = {};
      }

      if (permission.B2SAreaAllCurrentAndFuture && permission.B2SAreaSubarea.SubareaId) {
        if (!newGroupMappings.groupMappings.areaFlipped[permission.B2SAreaSubarea.SubareaId]) {
          newGroupMappings.groupMappings.areaFlipped[permission.B2SAreaSubarea.SubareaId] = {};
        }
        newGroupMappings.groupMappings.areaFlipped[permission.B2SAreaSubarea.SubareaId].areaOptions = 'allCurrentAndFuture';
      }
    });

    const newValues = { ...values, ...newGroupMappings };
    //newValues.groupSelected.PermissionGroupAreasSubAreas = null;
    setValues(newValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupSelected]);

  enum ValueStoreTypes {
    STRING,
    ARRAY,
  }

  const handleChange = (e: any, names: string[] | string, valueStoreType?: ValueStoreTypes) => {
    const newValues = { ...values };

    if (!Array.isArray(names)) {
      names = [names];
    }

    let newValuesStore = newValues;

    for (let i = 0; i < names.length - 1; i++) {
      const name = names[i];
      if (!newValuesStore[name]) {
        newValuesStore[name] = {};
      }
      newValuesStore = newValuesStore[name];
    }

    if (valueStoreType === ValueStoreTypes.ARRAY && !Array.isArray(newValuesStore[names[names.length - 1]])) {
      newValuesStore[names[names.length - 1]] = [];
    }
    if (valueStoreType === ValueStoreTypes.ARRAY) {
      newValuesStore[names[names.length - 1]].push(e.target.value);
    } else {
      newValuesStore[names[names.length - 1]] = e.target.value;
    }

    setValues(newValues);
  };

  const handleChangeFlipped = (data: boolean, areaId: string, subAreaId: string) => {
    const newValues = { ...values };

    let newValuesStore = newValues;

    if (!newValuesStore.groupMappings) {
      newValuesStore.groupMappings = {};
    }
    if (!newValuesStore.groupMappings.subArea) {
      newValuesStore.groupMappings.subArea = {};
    }
    if (!newValuesStore.groupMappings.subArea[areaId] || !newValuesStore.groupMappings.subArea[areaId].checked) {
      newValuesStore.groupMappings.subArea[areaId] = {
        checked: {},
      };
    }

    newValuesStore.groupMappings.subArea[areaId].checked[subAreaId] = data;

    setValues(newValues);
  };

  // eslint-disable-next-line
  const addGroup = async () => {
    // const result = await api.createUser(values.firstName, values.lastName, values.email, values.password, values.selectRole)
    //if (!values.groupMappings || !values.firstName) return;

    // eslint-disable-next-line
    const result = await api.addGroup(values.firstName, s.store?.organisationSelected?.organisationId); // TODO handle multiple orgs
    const mappings = Object.keys(values.groupMappings);

    for (let i = 0; i < mappings.length; i++) {}
    // getUsers();
  };

  // eslint-disable-next-line
  const addAdditional = async () => {
    //
    // const result = await api.createUser(values.firstName, values.lastName, values.email, values.password, values.selectRole)
    // getUsers();
    setMappingCount(mappingCount + 1);
  };

  // const submit = async () => {
  //

  //   const result = await api.addGroup(values.firstName, s.store.organisations[0].Id); // TODO handle multiple orgs

  //   const groupId = result.Id;

  //   if (!values.groupMappings || !values.groupMappings.subArea) return;

  //   //addPermissionAreaSubArea
  //   const areaIdKeys = Object.keys(values.groupMappings.subArea);

  //   for (let i = 0; i < areaIdKeys.length; i++) {
  //     const areaIdKey = areaIdKeys[i];
  //     const subAreaData = values.groupMappings.subArea[areaIdKey];

  //     if (!subAreaData.subAreaOptions || subAreaData.subAreaOptions !== 'allCurrentAndFuture') {

  //       const subAreaKeys = Object.keys(values.groupMappings.subArea[areaIdKey].checked);

  //       for (let j = 0; j < subAreaKeys.length; j++) {
  //         if (values.groupMappings.subArea[areaIdKey].checked[subAreaKeys[j]] === true) {
  //           const result = await api.addPermissionAreaSubArea(groupId, areaIdKey, subAreaKeys[j], undefined, undefined);
  //         }
  //       }

  //     } else if (subAreaData.subAreaOptions === 'allCurrentAndFuture') {
  //       const result = await api.addPermissionAreaSubArea(groupId, areaIdKey, undefined, true, undefined)
  //     }

  //   }

  // }

  const sortListSubAreas = (sortDirection: SORT_DIRECTION) => {
    const sortedList = sortList(subAreas, ['Name'], sortDirection);

    const newValues = { ...values };
    newValues.sortListSubAreaDirectionFlipped = sortDirection;
    setValues(newValues);
    setSubAreas(sortedList as any);
  };

  const sortListAreas = (sortDirection: SORT_DIRECTION) => {
    // sort areas
    subAreas.forEach((area: any) => {
      if (!Array.isArray(area.AreasSubareas)) return;
      const sortedList = sortList(area.AreasSubareas, ['Area', 'Name'], sortDirection);
      area.AreasSubareas = sortedList;
    });
    const newValues = { ...values };
    newValues.sortListAreaDirectionFlipped = sortDirection;
    setValues(newValues);
    setSubAreas(subAreas as any);
  };

  const groupMappings = (groupMappingId: number) => {
    return (
      <Fragment>
        <div className="card__linking-container--left card-body border p-0">
          <div className="p-3 pb-0">
            <div className="has-tools">
              <h5 className="mb-0">Subareas</h5>
              <div
                className="btn btn-outline-secondary btn-sm btn-sort-width"
                onClick={(e) => {
                  sortListSubAreas(values.sortListSubAreaDirectionFlipped === undefined || values.sortListSubAreaDirectionFlipped === SORT_DIRECTION.ASC ? SORT_DIRECTION.DEC : SORT_DIRECTION.ASC);
                }}>
                {values.sortListSubAreaDirectionFlipped === undefined || values.sortListSubAreaDirectionFlipped === SORT_DIRECTION.ASC ? 'Ascending' : 'Descending'}
                <i
                  className={
                    values.sortListSubAreaDirectionFlipped === undefined || values.sortListSubAreaDirectionFlipped === SORT_DIRECTION.ASC
                      ? 'fa-solid fa-arrow-down-short-wide ms-1'
                      : 'fa-solid fa-arrow-up-wide-short ms-1'
                  }
                />
              </div>
            </div>
            <input
              type="text"
              className="form-control form-control-sm my-3"
              placeholder="Search Subareas"
              onChange={(e) => {
                handleChange(e, 'filterSubAreaFlipped');
              }}
              value={values.filterSubAreaFlipped}
            />
          </div>
          <hr className="my-4 mb-0" />
          <div className="form-check__container form-check__container--left" style={{ maxHeight: 'calc(100vh - 630px)' }}>
            {subAreas.map((subArea: any) => {
              if (values.filterSubAreaFlipped && values.filterSubAreaFlipped !== '' && subArea.Name.toLowerCase().indexOf(values.filterSubAreaFlipped.toLowerCase()) === -1) {
                return <Fragment></Fragment>;
              }

              return (
                <div className="form-check">
                  <div
                    className={(() => {
                      if (!values.groupMappings || !values.groupMappings.subArea) return;
                      const areaIdKeys = Object.keys(values.groupMappings.subArea);
                      for (let i = 0; i < areaIdKeys.length; i++) {
                        const areaData = values.groupMappings.subArea[areaIdKeys[i]];
                        if (areaData.subAreaOptions === 'allCurrentAndFuture') return 'form-check__active-indicator';

                        if (areaData.checked && areaData.checked[subArea.Id]) {
                          return 'form-check__active-indicator';
                        }
                      }
                    })()}>
                    <input
                      autoComplete="off"
                      type="radio"
                      id={'subAreaFlipped' + subArea.Id}
                      name={'subAreaFlipped'}
                      className="form-check-input"
                      value={subArea.Id}
                      checked={values.groupMappings && values.groupMappings?.subAreaFlipped === subArea.Id}
                      onChange={(e) => {
                        handleChange(e, ['groupMappings', 'subAreaFlipped']);
                      }}
                    />
                    <label className="form-check-label" htmlFor={'subAreaFlipped' + subArea.Id}>
                      {subArea.Name}
                    </label>
                  </div>
                </div>
              );
            })}{' '}
          </div>
        </div>
        <div className="card__linking-container--middle bg-light border-top border-bottom d-flex align-items-center justify-content-center">
          <i className="fa-solid fa-arrow-right" />
        </div>

        <div className="card__linking-container--right card-body border p-0">
          <div className="p-3 pb-0">
            <div className="has-tools">
              <h5 className="mb-0">Areas</h5>
              <div
                className="btn btn-outline-secondary btn-sm btn-sort-width"
                onClick={(e) => {
                  sortListAreas(values.sortListAreaDirectionFlipped === undefined || values.sortListAreaDirectionFlipped === SORT_DIRECTION.ASC ? SORT_DIRECTION.DEC : SORT_DIRECTION.ASC);
                }}>
                {values.sortListAreaDirectionFlipped === undefined || values.sortListAreaDirectionFlipped === SORT_DIRECTION.ASC ? 'Ascending' : 'Descending'}
                <i
                  className={
                    values.sortListAreaDirectionFlipped === undefined || values.sortListAreaDirectionFlipped === SORT_DIRECTION.ASC
                      ? 'fa-solid fa-arrow-down-short-wide ms-1'
                      : 'fa-solid fa-arrow-up-wide-short ms-1'
                  }
                />
              </div>
            </div>
            <input
              type="text"
              className="form-control form-control-sm my-3"
              placeholder="Search Areas"
              onChange={(e) => {
                handleChange(e, 'filterAreaFlipped');
              }}
              value={values.filterAreaFlipped}
            />
          </div>

          {subAreas.map((subArea: any, index: number) => {
            //if (!values.groupMappings || values.groupMappings?.subAreaFlipped !== subArea.Id) return;
            //if (!Array.isArray(subArea.AreasSubareas)) return;

            if (
              (values.groupMappings && values.groupMappings?.subAreaFlipped && values.groupMappings.subAreaFlipped !== subArea.Id) ||
              ((!values.groupMappings || !values.groupMappings.subAreaFlipped) && index > 0)
            ) {
              return <Fragment />;
            }

            let allFutureOptions = ['groupMappings', 'areaFlipped', `${subArea.Id}`, 'areaOptions'];
            let allFutureOptionsValue = values.groupMappings && values.groupMappings.areaFlipped && values.groupMappings.areaFlipped[`${subArea.Id}`]?.areaOptions;
            if (!values.groupMappings || values.groupMappings?.subAreaFlipped !== subArea.Id) {
              allFutureOptions = ['groupMappings', 'areaGlobal', 'areaOptions'];
              allFutureOptionsValue = values.groupMappings && values.groupMappings.areaGlobal && values.groupMappings.areaGlobal.areaOptions;
            }

            const subAreaBoxes: any[] = [];

            subAreaBoxes.push(
              <Fragment>
                <div className="px-3">
                  <div className="form-check">
                    <input
                      autoComplete="off"
                      type="radio"
                      id={'allCurrentAndFuture' + subArea.Id}
                      name={'areaOptions' + subArea.Id}
                      className="form-check-input"
                      value={'allCurrentAndFuture'}
                      //checked={values.groupMappings && values.groupMappings.areaOptions && values.groupMappings.areaOptions === 'allCurrentAndFuture'}
                      checked={allFutureOptionsValue === 'allCurrentAndFuture'}
                      onChange={(e) => {
                        //handleChange(e, ['groupMappings', 'areaOptions']);
                        handleChange(e, allFutureOptions);
                      }}
                    />
                    <label className="form-check-label" htmlFor={'allCurrentAndFuture' + subArea.Id}>
                      All current and future
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      autoComplete="off"
                      type="radio"
                      id={'allCurrent' + subArea.Id}
                      name={'areaOptions' + subArea.Id}
                      className="form-check-input"
                      value={'allCurrent'}
                      checked={allFutureOptionsValue === 'allCurrent'}
                      onChange={(e) => {
                        handleChange(e, allFutureOptions);
                      }}
                    />
                    <label className="form-check-label" htmlFor={'allCurrent' + subArea.Id}>
                      All current
                    </label>
                  </div>
                </div>
              </Fragment>
            );

            subAreaBoxes.push(<hr className="my-4 mb-0" />);

            if (!values.groupMappings || !values.groupMappings.subAreaFlipped) return subAreaBoxes;
            if (!Array.isArray(subArea.AreasSubareas)) return <Fragment />;

            const subAreaBoxesMain: any = [];
            subArea.AreasSubareas.forEach((areasSubarea: any) => {
              if (!areasSubarea.Area) return;

              if (values.filterAreaFlipped && values.filterAreaFlipped !== '' && areasSubarea.Area.Name.toLowerCase().indexOf(values.filterAreaFlipped.toLowerCase()) === -1) {
                return;
              }

              subAreaBoxesMain.push(
                <div className="form-check">
                  <input
                    autoComplete="off"
                    type="checkbox"
                    className="form-check-input"
                    id={'areaFlipped' + subArea.Id + areasSubarea.Area.Id}
                    checked={
                      //   values.groupMappings && values.groupMappings.areaFlipped
                      // && values.groupMappings.areaFlipped[`${subArea.Id}`]
                      // && values.groupMappings.areaFlipped[`${subArea.Id}`].checked
                      // && values.groupMappings.areaFlipped[`${subArea.Id}`].checked[areasSubarea.Area.Id]? true :
                      values.groupMappings &&
                        values.groupMappings.subArea &&
                        values.groupMappings.subArea[`${areasSubarea.Area.Id}`] &&
                        values.groupMappings.subArea[`${areasSubarea.Area.Id}`].checked &&
                        values.groupMappings.subArea[`${areasSubarea.Area.Id}`].checked[subArea.Id]
                        ? true
                        : false
                    }
                    onChange={(e) => {
                      // handleChange({
                      //   target: { value: e.target.checked }
                      // }, ['groupMappings', 'areaFlipped', `${subArea.Id}`, 'checked', areasSubarea.Area.Id]);
                      handleChangeFlipped(e.target.checked, areasSubarea.Area.Id, subArea.Id);
                    }}
                  />
                  <label className="form-check-label" htmlFor={'areaFlipped' + subArea.Id + areasSubarea.Area.Id}>
                    {areasSubarea.Area.Name}
                  </label>
                </div>
              );
              //subAreaBoxes.push(<div>{area.Name}</div>);
              //return subAreaBoxes;
              // if (subArea.Id === values.groupMappings.subAreaFlipped) {
              //   //subAreaBoxes.push(<div>{area.Name} {values.groupMappings.subAreaFlipped} {subArea.Name}</div>);
              //   subAreaBoxes.push(<div>{area.Name} {values.groupMappings.subAreaFlipped} {subArea.Name}</div>);
              //   //return subAreaBoxes;
              // }
              //return;

              // subAreaBoxes.push(
              //   <div className="form-check">
              //     <input
              //       autoComplete="off"
              //       type="checkbox"
              //       className="form-check-input"
              //       id={'subArea'+area.Id+subArea.Id}
              //       checked={values.groupMappings && values.groupMappings.subArea
              //       && values.groupMappings.subArea[`${area.Id}`]
              //       && values.groupMappings.subArea[`${area.Id}`].checked
              //       && values.groupMappings.subArea[`${area.Id}`].checked[subArea.Id]? true : false}
              //       onChange={(e) => {
              //         handleChange({
              //           target: { value: e.target.checked }
              //         }, ['groupMappings', 'subArea', `${area.Id}`, 'checked', subArea.Id]);
              //       }}
              //     />
              //     <label className="form-check-label" htmlFor={'subArea'+area.Id+subArea.Id} >{subArea.Name}</label>
              //   </div>
              // );
            });
            subAreaBoxes.push(
              <div className="form-check__container form-check__container--right" style={{ maxHeight: 'calc(100vh - 691px)' }}>
                {subAreaBoxesMain}
              </div>
            );
            return subAreaBoxes;
          })}
        </div>
      </Fragment>
    );
  };

  return (
    <div>
      <div className="card steps-header" style={{ backgroundColor: '#F0F0F1' }}>
        <div className="steps-header__step active">1. Areas</div>
        <span />
        <div className="steps-header__step active">2. Subreas</div>
        <span />
        <div className="steps-header__step">3. Versions &amp; Milestones</div>
        <span />
        <div className="steps-header__step">
          <i className="fas fa-check" />
        </div>
      </div>
      <div className="p-4 pb-0">
        <label htmlFor="groupName" className="mb-2">
          Security Group Name
        </label>
        <input type="text" className="form-control" id="groupName" name="groupName" placeholder="Security Group Name" onChange={(e) => handleChange(e, 'firstName')} value={values.firstName} />
      </div>

      <div>
        <div className="card__linking-container p-4">{groupMappings(0)}</div>
        <div className="d-flex align-items-center justify-content-between px-4 pb-5">
          <button
            className="btn btn-outline-dark"
            onClick={() => {
              back(values);
            }}>
            <i className="fa-solid fa-arrow-left" />
            Back
          </button>
          <button
            className="btn btn-success"
            onClick={() => {
              next(values);
            }}>
            Next
            <i className="fa-solid fa-arrow-right" />
          </button>
        </div>
      </div>

      {/* {(()=>{
          let count = 0;
          const display = [];
          do {
            display.push(groupMappings(count))
            count++;
          } while(count <= mappingCount);
          display.push(  <button onClick={() => {
            addAdditional();
          }}>Add additional area mapping</button>);
          return display;
        })()} */}
    </div>
  );
};

export default withRouter(GroupNewAreaFlipped);
